import React from "react";

const TOKENS = [
  "DJANGO", "FASTAPI", "POSTGRESQL", "DOCKER", "KUBERNETES", "AWS", "REDIS",
  "RABBITMQ", "ANGULAR", "REACT", "TYPESCRIPT", "NODE.JS", "PYTHON", "RAG / AI",
];

function Track({ hidden }) {
  return (
    <div className="marquee-group mono" aria-hidden={hidden ? "true" : undefined}>
      {TOKENS.map((token, i) => (
        <React.Fragment key={i}>
          <span>{token}</span>
          <span>·</span>
        </React.Fragment>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee">
      <div className="marquee-track">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
}
